import { CreateServiceOrderModal } from "@features/ax/shared/serviceOrderModal";
import { useToast } from "@shared/hooks/use-toast";
import { Button } from "@shared/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Edit, EyeOff, Wrench } from "lucide-react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useIgnoreIncident } from "../../hooks";
interface QuickActionsCardProps {
  hasLinkedAssets: boolean;
  isIgnored: boolean;
  incidentDetails: any;
}

export const QuickActionsCard = ({
  hasLinkedAssets,
  isIgnored,
  incidentDetails,
}: QuickActionsCardProps) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { mutateAsync: ignoreIncident, isPending: isUpdating } =
    useIgnoreIncident(true);
  const { toast } = useToast();

  const [isCreateSOModalOpen, setIsCreateSOModalOpen] = useState(false);
  const [isCreatingServiceOrder, setIsCreatingServiceOrder] = useState(false);
  const handleConfirmIgnore = async () => {
    ignoreIncident({
      id: id,
      payload: { status: "4" },
    });
  };
  const handleCreateServiceOrderClick = () => {
    setIsCreateSOModalOpen(true);
  };

  const handleCreateServiceOrder = async (data: any) => {
    setIsCreatingServiceOrder(true);
    try {
      toast({
        title: "Success",
        description: "Service order created successfully",
        variant: "default",
      });
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to create service order",
        variant: "destructive",
      });
    } finally {
      setIsCreatingServiceOrder(false);
    }
  };
  return (
    <Card>
      <CardHeader>
        <CardTitle>Quick Actions</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col space-y-3">
        <Button
          variant="outline"
          className="w-full justify-start"
          onClick={() =>
            navigate(`/ax/field-alerts/incidents/create/edit/${id}`)
          }
        >
          <Edit className="w-4 h-4 mr-2" />
          Edit Incident Report
        </Button>

        <Button
          variant="outline"
          className="w-full justify-start"
          disabled={
            isIgnored ||
            incidentDetails?.asset === null ||
            incidentDetails === "Service Order Created"
          }
          tooltip={
            isIgnored
              ? "This action is disabled because it is ignored."
              : incidentDetails?.asset === null
              ? "No asset is linked to this incident."
              : incidentDetails === "Service Order Created"
              ? "Service order is already created."
              : undefined
          }
          onClick={handleCreateServiceOrderClick}
        >
          <Wrench className="w-4 h-4 mr-2" />
          Create Service Order
        </Button>

        <Button
          variant="outline"
          className="w-full justify-start"
          isLoading={isUpdating}
          onClick={() => handleConfirmIgnore()}
          disabled={isIgnored}
        >
          <EyeOff className="w-4 h-4 mr-2" />
          Ignore Incident
        </Button>
      </CardContent>
      <CreateServiceOrderModal
        isOpen={isCreateSOModalOpen}
        onClose={() => setIsCreateSOModalOpen(false)}
        onSubmit={handleCreateServiceOrder}
        incidentId={id}
        requestDetails={incidentDetails}
      />
    </Card>
  );
};
